import React from "react";
import SmsLogPanel from "@/components/SmsLogPanel";
import PODDiagnosticsPanel from "@/components/PODDiagnosticsPanel";
import RestrictedZipsPanel from "@/components/RestrictedZipsPanel";
import GlobalAuditPanel from "@/components/GlobalAuditPanel";
import IntegrationGuideUrlsPanel from "@/components/IntegrationGuideUrlsPanel";
import { ScrollText } from "lucide-react";

/**
 * /admin/audit-log (and /dispatch/audit-log) — central place for all
 * audit-style telemetry. Hosts the Customer SMS log and the POD delivery
 * diagnostics (storage smoke test + recent deliver failures). Future
 * additions (global order status history, login events, etc.) will land
 * here side-by-side.
 */
export default function AdminAuditLog() {
  return (
    <div className="p-6 lg:p-10 max-w-[1400px] mx-auto" data-testid="audit-log-page">
      <header className="mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-[11px] uppercase tracking-[0.18em] font-semibold mb-3">
          <ScrollText className="h-3 w-3" /> Audit
        </div>
        <h1 className="text-3xl lg:text-4xl font-display font-bold tracking-tight">Audit log</h1>
        <p className="text-muted-foreground mt-1.5 max-w-2xl">
          Outbound activity from the platform — patient notifications, POD delivery diagnostics, and other telemetry. Everything that leaves SRCI Pharm-Route is recorded here.
        </p>
      </header>

      <section data-testid="audit-section-integration-guide" className="mb-6">
        <IntegrationGuideUrlsPanel />
      </section>

      <section data-testid="audit-section-restricted-zips" className="mb-6">
        <RestrictedZipsPanel />
      </section>

      <section data-testid="audit-section-global-feed" className="mb-6">
        <GlobalAuditPanel />
      </section>

      <section data-testid="audit-section-diagnostics" className="mb-6">
        <PODDiagnosticsPanel />
      </section>

      <section data-testid="audit-section-sms">
        <SmsLogPanel />
      </section>
    </div>
  );
}
